'use client'

import { LuneTheme } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Forto from '@public/images/logos/forto.png'
import Gocomet from '@public/images/logos/gocomet.png'
import Imperative from '@public/images/logos/imperative.png'
import Jas from '@public/images/logos/jas.svg'
import Logixboard from '@public/images/logos/logixboard.png'
import Paack from '@public/images/logos/paack.png'

import LogosGrid from '@/components/LogosGrid'

const logos = [
    {
        name: 'Jas',
        img: Jas,
        width: 83.72,
        height: 32,
    },
    {
        name: 'Forto',
        img: Forto,
        width: 77.68,
        height: 19,
    },
    {
        name: 'Logixboard',
        img: Logixboard,
        width: 140.52,
        height: 16,
    },
    {
        name: `Paack`,
        img: Paack,
        width: 92,
        height: 32,
    },
    {
        name: 'Imperative',
        img: Imperative,
        width: 113.5,
        height: 24,
    },
    {
        name: 'Gocomet',
        img: Gocomet,
        width: 126.94,
        height: 17,
    },
]

const EmbedClimateContributionsLogos = () => {
    const { palette } = LuneTheme
    return (
        <>
            <Box
                sx={{
                    position: 'relative',
                    '&:after': {
                        content: '""',
                        position: 'absolute',
                        bottom: 0,
                        left: '-50%',
                        right: '-50%',
                        height: '1px',
                        backgroundColor: `${palette.Grey300}`,
                        mx: {
                            lg: 37,
                            xl: 37,
                        },
                    },
                }}
            >
                <LogosGrid sx={{ pt: 6, pb: 6 }} logos={logos} />
            </Box>
        </>
    )
}

export default EmbedClimateContributionsLogos
